import type { Pinia } from 'pinia'
import type { User } from '~/types/user'
import { isPagePathAllowed, TELEMEDICINE_HOME } from '~/utils/telemedicineAccess'

// Reads the auth store through Pinia state instead of useAuthStore(): global middleware is
// imported eagerly, and stores/auth.ts calls useNuxtApp() at module scope.
export default defineNuxtRouteMiddleware((to) => {
    const pinia = useNuxtApp().$pinia as Pinia | undefined
    const user = (pinia?.state.value.auth as { user?: User } | undefined)?.user
    if (user && !isPagePathAllowed(user.role, to.path)) {
        return navigateTo(TELEMEDICINE_HOME)
    }
})
